import {ReactElement} from "react";
export interface SquareTileIconProps{
    icon:ReactElement<any, any>;
    
}
export function SquareTileIcon (props:SquareTileIconProps){
    return <>
        <span className={"icon"}>
            {props.icon}
        </span>

    </>
}